import styled, { css } from 'styled-components';

import { DiamondIcon, theme } from '@notino/react-styleguide';

interface LoyaltyDiscountStyledWrapperProps {
  isCustomerDiscount: boolean;
  newDesign: boolean;
}

export const LoyaltyDiscountStyledWrapper = styled.button<LoyaltyDiscountStyledWrapperProps>`
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  text-decoration: ${({ isCustomerDiscount }) =>
    isCustomerDiscount ? 'none' : 'underline'};
  cursor: pointer;
  background: none;
  border: none;
  color: #000 !important;
  &:hover {
    text-decoration: none;
  }

  ${({ newDesign }) =>
    newDesign &&
    css`
      color: ${theme.color.text.secondary} !important;
    `}
`;

export const CustomerDiscountWrapper = styled.span`
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`;

export const StyledDiamondIcon = styled(DiamondIcon)`
  margin-right: 1rem;
`;

export const CustomerDiscountBoldWrapper = styled.span`
  font-weight: 600;
`;
